// Maison Labroca — data (palette beige/noir uniforme)

export const heroVideoUrl =
  "https://framerusercontent.com/assets/y7ynbURmYFbAgOFqhlmuLl3XJw.mp4";

export const logoUrl = "/assets/logo-maisonlabroca.png";

// PALETTE
export const palette = {
  beigeLight: "#E9E1D4",
  beigeSand: "#D5C4AE",
  beigeDeep: "#9F8B76", // taupe
  black: "#111111",
  offWhite: "#F7F4EF",
};

export const socials = {
  linkedin: "https://www.linkedin.com/company/maison-labroca",
  instagram: "https://www.instagram.com/maison.labroca",
};

export const contactInfo = {
  email: "maisonlabroca.contact@gmail.com",
  location: "Paris, Île-de-France",
  zone: "Île-de-France et alentours",
  founded: 2004,
  sector: "Construction de bâtiments résidentiels",
};

export const formspreeEndpoint = "https://formspree.io/f/xaqgaozv";

export const activityImages = {
  construction:
    "https://images.unsplash.com/photo-1777919393703-ad0a60555274?w=1400",
  maison:
    "https://images.pexels.com/photos/7031581/pexels-photo-7031581.jpeg?auto=compress&cs=tinysrgb&w=1400",
  renovation:
    "https://images.unsplash.com/photo-1505798577917-a65157d3320a?w=1400",
  grosOeuvre:
    "https://images.pexels.com/photos/7108785/pexels-photo-7108785.jpeg?auto=compress&cs=tinysrgb&w=1400",
};

export const panelImages = {
  villa:
    "https://images.pexels.com/photos/29334668/pexels-photo-29334668.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  entree:
    "https://images.unsplash.com/photo-1700226034367-2fb120f48dfa",
  salon:
    "https://images.unsplash.com/photo-1648881806148-e5c51179c826",
  interieur:
    "https://images.unsplash.com/photo-1688647063090-36f36f692d95",
  moderne:
    "https://images.unsplash.com/photo-1591474200742-8e512e6f98f8",
  bois:
    "https://images.unsplash.com/photo-1706808849777-96e0d7be3bb7",
  serviceFaisabilite: "/assets/service-faisabilite.jpg",
  serviceDemarches: "/assets/service-demarches.jpg",
  servicePlans: "/assets/service-plans.jpg",
  service3d: "/assets/service-3d.jpg",
};

export const teamPhotos = {
  antonio: "/assets/tony-pro.jpg",
  matteo: "/assets/matteo-pro.jpg",
  romane: "/assets/romane-pro.jpg",
  eva: "/assets/eva-pro.jpg",
};

export const team = [
  {
    id: "antonio",
    initials: "AL",
    name: "Antonio Labroca",
    role: "Fondateur & Directeur Général",
    photo: teamPhotos.antonio,
  },
  {
    id: "matteo",
    initials: "ML",
    name: "Matteo Labroca",
    role: "Directeur des Opérations & Associé",
    photo: teamPhotos.matteo,
  },
  {
    id: "eva",
    initials: "EL",
    name: "Eva Labroca",
    role: "Directrice de l'Expérience Client & Associée",
    photo: teamPhotos.eva,
  },
  {
    id: "romane",
    initials: "RL",
    name: "Romane Labroca",
    role: "Directrice Marketing & Communication & Associée",
    photo: teamPhotos.romane,
  },
];

export const activites = [
  {
    id: "construction",
    num: "01",
    title: "CONSTRUCTION CLÉ EN MAIN",
    subtitle: "Maisons individuelles sur-mesure",
    text:
      "Construction neuve sur mesure, de la recherche du terrain à la remise des clés, en coordonnant l'ensemble des intervenants.",
    image: activityImages.construction,
    details: [
      "En tant que maître d'œuvre, nous prenons en charge votre projet dans sa globalité : recherche de terrain, étude de faisabilité, démarches administratives nécessaires, conception des plans, puis coordination de l'ensemble des intervenants jusqu'à la livraison clés en main.",
      "Une maison individuelle sur-mesure, pensée pour vous, dessinée selon vos envies et adaptée à votre terrain, du premier coup de crayon à la remise des clés.",
    ],
    highlights: [
      "Recherche de terrain et étude de faisabilité",
      "Démarches administratives nécessaires au projet",
      "Conception des plans et coordination de tous les intervenants",
      "Livraison clés en main de votre maison sur-mesure",
    ],
  },
  {
    id: "collectif",
    num: "02",
    title: "PROGRAMMES IMMOBILIERS & COLLECTIFS",
    subtitle: "Lotissements, petits collectifs, projets d'envergure",
    text:
      "Conception et réalisation de programmes immobiliers collectifs, pour investisseurs, promoteurs et projets d'envergure.",
    image: activityImages.grosOeuvre,
    details: [
      "Au-delà de la maison individuelle, nous intervenons sur des projets de plus grande envergure : petits collectifs, lotissements, programmes immobiliers pour investisseurs ou promoteurs.",
      "Ces projets demandent une coordination technique rigoureuse et une bonne connaissance des enjeux réglementaires propres aux opérations d'envergure — c'est ce que nous apportons à chaque programme.",
    ],
    highlights: [
      "Petits collectifs et lotissements",
      "Accompagnement d'investisseurs et de promoteurs",
      "Coordination technique de bout en bout",
      "Projets d'envergure, du foncier à la livraison",
    ],
  },
  {
    id: "renovation",
    num: "03",
    title: "RÉNOVATION TOUS CORPS D'ÉTAT",
    subtitle: "Du studio à la villa complète",
    text:
      "Rénovations globales ou ciblées, pour tous types de biens, du diagnostic aux finitions.",
    image: activityImages.renovation,
    details: [
      "Qu'il s'agisse d'une rénovation complète ou d'une intervention ciblée sur une pièce, nous adaptons notre approche à l'ampleur réelle de votre projet et à l'état de votre bien existant.",
      "Tous corps d'état confondus : plus besoin de coordonner vous-même plusieurs artisans, nous gérons l'ensemble pour un résultat cohérent, dans les délais annoncés.",
    ],
    highlights: [
      "Rénovation globale ou ciblée selon vos besoins",
      "Tous corps d'état, du gros œuvre aux finitions",
      "Rénovation de cuisine, salle de bain, ou pièce à vivre",
      "Tous types de biens : appartement, maison, local",
    ],
  },
];

// Services — 4 themes beige/noir
export const servicePanels = [
  {
    id: "faisabilite",
    number: "01",
    title: "Étude de faisabilité",
    signature: "Faisability",
    description:
      "Analyse préalable pour valider la viabilité technique, réglementaire et financière de votre projet immobilier.",
    details: [
      "Avant tout engagement, nous analysons votre terrain ou votre bien existant pour vérifier que votre projet est réalisable : règles d'urbanisme locales (PLU), contraintes de hauteur et d'implantation, nature du sol, servitudes éventuelles.",
      "Cette étude nous permet également d'établir une première estimation budgétaire réaliste, afin que vous puissiez avancer en toute connaissance de cause avant d'investir davantage de temps et de moyens dans le projet.",
    ],
    highlights: [
      "Analyse du terrain et des règles d'urbanisme (PLU)",
      "Vérification des contraintes techniques et réglementaires",
      "Première estimation budgétaire",
    ],
    image: "serviceFaisabilite",
    theme: "beigeLight",
  },
  {
    id: "demarches",
    number: "02",
    title: "Démarches administratives",
    signature: "Administration",
    description:
      "Nous prenons en charge l'ensemble des démarches administratives : permis de construire, déclarations préalables et autorisations.",
    details: [
      "Le montage et le suivi d'un dossier administratif peuvent vite devenir un frein pour un particulier. Nous nous en chargeons intégralement : constitution du dossier de permis de construire ou de déclaration préalable, dépôt en mairie et suivi jusqu'à l'obtention de l'accord.",
      "Nous coordonnons également les études techniques obligatoires (étude thermique, étude de sol si nécessaire) et veillons à la conformité de votre projet avec la réglementation en vigueur, notamment la RE2020 pour les constructions neuves.",
    ],
    highlights: [
      "Constitution et dépôt du dossier de permis de construire",
      "Suivi avec les services d'urbanisme de la mairie",
      "Coordination des études techniques obligatoires",
    ],
    image: "serviceDemarches",
    theme: "black",
  },
  {
    id: "plans",
    number: "03",
    title: "Plans techniques",
    signature: "Blueprints",
    description:
      "Réalisation des plans techniques, coupes et élévations pour concrétiser votre projet avec précision.",
    details: [
      "Une fois le projet validé, nous établissons l'ensemble des plans nécessaires à sa réalisation : plans de masse, plans de niveaux, coupes et élévations, en cohérence avec le dossier de permis déposé.",
      "Ces documents techniques servent de base à l'ensemble des corps de métier intervenant sur le chantier, garantissant une exécution fidèle au projet validé, sans approximation ni improvisation en cours de construction.",
    ],
    highlights: [
      "Plans de masse et plans de niveaux détaillés",
      "Coupes et élévations techniques",
      "Documents de référence pour tous les corps de métier",
    ],
    image: "servicePlans",
    theme: "beigeSand",
  },
  {
    id: "3d",
    number: "04",
    title: "Visualisations 3D",
    signature: "3D Visuals",
    badge: "En cours de préparation",
    description:
      "Visualisez votre projet avant même sa réalisation grâce à des rendus 3D photoréalistes et immersifs.",
    details: [
      "Avant le premier coup de pelle, nous vous proposons des rendus 3D réalistes de votre futur bien : volumes, matériaux, luminosité, aménagements extérieurs. De quoi visualiser concrètement le résultat final et ajuster certains choix si besoin.",
      "Cet outil facilite les échanges et les décisions tout au long du projet, en particulier sur les finitions et l'agencement, avant que les travaux ne soient engagés.",
    ],
    highlights: [
      "Rendus 3D photoréalistes de votre projet",
      "Visualisation des volumes, matériaux et finitions",
      "Aide à la décision avant le lancement des travaux",
    ],
    image: "service3d",
    theme: "beigeDeep",
  },
];

// Chiffres clés
export const chiffres = [
  { id: "projets", kind: "number", value: 200, suffix: "+", label: "projets réalisés" },
  { id: "experience", kind: "number", value: 40, suffix: "+", label: "années d'expérience" },
  { id: "creation", kind: "number", value: 2004, suffix: "", label: "année de création", noFormat: true },
];

export const googleReviews = {
  rating: null,
  count: 0,
  reviews: [],
};

export const beforeAfterImages = {
  before:
    "https://framerusercontent.com/images/56ecmYKmAvnp4bUjamaig3dmj1Y.jpg?width=1552&height=2048",
  after:
    "https://framerusercontent.com/images/rd4Re6Ewf9YzpiQvyIvLFpYWzXo.jpg?width=1540&height=2048",
};
